<template>
  <div>
    <div class="space-y-2 text-[14px]">
      <div :class="{ 'flex justify-between': isDesktop }">
        <p class="text-grey-light-700" :class="{ 'font-bold': !isDesktop }">Refund amount before deductions</p>
        <p class="text-grey-light-900">{{ displayCurrency(refundBeforeDeductions) }}</p>
      </div>
      <div :class="{ 'flex justify-between text-[14px]': isDesktop }">
        <p class="text-grey-light-700" :class="{ 'font-bold': !isDesktop }">Cancellation fee</p>
        <p class="text-grey-light-900" :class="{ 'font-bold': isDesktop }">{{ displayCurrency(cancellationFee) }}</p>
      </div>
    </div>

    <hr class="my-4" />

    <div :class="{ 'flex justify-between': isDesktop }">
      <p class="text-grey-light-600" :class="{ 'font-bold': !isDesktop }">Refund amount after deductions</p>
      <p class="text-grey-light-900" :class="{ 'font-bold': isDesktop }">
        {{ displayCurrency(refundAfterDeductions) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { displayCurrency } from '@/utils/format.utils';
import { useBreakpoint } from '@/utils/useBreakPoint';

const { isDesktop } = useBreakpoint();

defineProps<{
  refundBeforeDeductions: number;
  cancellationFee: number;
  refundAfterDeductions: number;
}>();
</script>
